import { createAction } from 'redux-actions'

const ns = 'companies/'

export const getCompanyRanking = createAction(`${ns}GET_COMPANY_RANKING`)
export const getCompanyRankingSuccess = createAction(`${ns}GET_COMPANY_RANKING_SUCCESS`)
export const getCompanyRankingFail = createAction(`${ns}GET_COMPANY_RANKING_FAIL`)

export const toggleCompanyExcludedFromRanking = createAction(`${ns}TOGGLE_COMPANY_EXCLUDED_FROM_RANKING`)
